/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Anexo } from '../model/anexo';
import { ConfiguracaoEmail } from '../model/configuracaoEmail';
import { Destinatario } from '../model/destinatario';
import { MensagemEmail } from '../model/mensagemEmail';
import { NewMensagemEmail } from '../model/newMensagemEmail';
import { StatusEnvio } from '../model/statusEnvio';
import { TipoMensagem } from '../model/tipoMensagem';
import { UpdConfiguracaoEmail } from '../model/updConfiguracaoEmail';
import { UpdMensagemEmail } from '../model/updMensagemEmail';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';

@Injectable()
export class MensagensApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Excluir Anexo de Mensagem de E-mail
     * 
     * @param anexoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensAnexosAnexoIdDelete(anexoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1MensagensAnexosAnexoIdDelete(anexoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1MensagensAnexosAnexoIdDelete(anexoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1MensagensAnexosAnexoIdDelete(anexoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anexoId === null || anexoId === undefined) {
            throw new Error('Required parameter anexoId was null or undefined when calling v1MensagensAnexosAnexoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/mensagens/anexos/${encodeURIComponent(String(anexoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fazer Download do Anexo da Mensagem de E-mail
     * 
     * @param anexoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensAnexosAnexoIdGet(anexoId: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public v1MensagensAnexosAnexoIdGet(anexoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public v1MensagensAnexosAnexoIdGet(anexoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public v1MensagensAnexosAnexoIdGet(anexoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anexoId === null || anexoId === undefined) {
            throw new Error('Required parameter anexoId was null or undefined when calling v1MensagensAnexosAnexoIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/v1/mensagens/anexos/${encodeURIComponent(String(anexoId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Configurações de Envio de Emails
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensConfiguracaoGet(observe?: 'body', reportProgress?: boolean): Observable<ConfiguracaoEmail>;
    public v1MensagensConfiguracaoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfiguracaoEmail>>;
    public v1MensagensConfiguracaoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfiguracaoEmail>>;
    public v1MensagensConfiguracaoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ConfiguracaoEmail>('get',`${this.basePath}/v1/mensagens/configuracao`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Definir Configurações de Envio de Emails
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensConfiguracaoPost(body?: UpdConfiguracaoEmail, observe?: 'body', reportProgress?: boolean): Observable<ConfiguracaoEmail>;
    public v1MensagensConfiguracaoPost(body?: UpdConfiguracaoEmail, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfiguracaoEmail>>;
    public v1MensagensConfiguracaoPost(body?: UpdConfiguracaoEmail, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfiguracaoEmail>>;
    public v1MensagensConfiguracaoPost(body?: UpdConfiguracaoEmail, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ConfiguracaoEmail>('post',`${this.basePath}/v1/mensagens/configuracao`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Enviar E-mail de Teste
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensConfiguracaoTestarPost(body?: Destinatario, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public v1MensagensConfiguracaoTestarPost(body?: Destinatario, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public v1MensagensConfiguracaoTestarPost(body?: Destinatario, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public v1MensagensConfiguracaoTestarPost(body?: Destinatario, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/v1/mensagens/configuracao/testar`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Mensagens de E-mail
     * 
     * @param pessoaJuridicaId 
     * @param emailAddress 
     * @param avaliacaoId 
     * @param statusEnvio 
     * @param tipoMensagem 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensGet(pessoaJuridicaId?: number, emailAddress?: string, avaliacaoId?: number, statusEnvio?: StatusEnvio, tipoMensagem?: TipoMensagem, observe?: 'body', reportProgress?: boolean): Observable<Array<MensagemEmail>>;
    public v1MensagensGet(pessoaJuridicaId?: number, emailAddress?: string, avaliacaoId?: number, statusEnvio?: StatusEnvio, tipoMensagem?: TipoMensagem, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MensagemEmail>>>;
    public v1MensagensGet(pessoaJuridicaId?: number, emailAddress?: string, avaliacaoId?: number, statusEnvio?: StatusEnvio, tipoMensagem?: TipoMensagem, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MensagemEmail>>>;
    public v1MensagensGet(pessoaJuridicaId?: number, emailAddress?: string, avaliacaoId?: number, statusEnvio?: StatusEnvio, tipoMensagem?: TipoMensagem, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pessoaJuridicaId !== undefined && pessoaJuridicaId !== null) {
            queryParameters = queryParameters.set('pessoaJuridicaId', <any>pessoaJuridicaId);
        }
        if (emailAddress !== undefined && emailAddress !== null) {
            queryParameters = queryParameters.set('emailAddress', <any>emailAddress);
        }
        if (avaliacaoId !== undefined && avaliacaoId !== null) {
            queryParameters = queryParameters.set('avaliacaoId', <any>avaliacaoId);
        }
        if (statusEnvio !== undefined && statusEnvio !== null) {
            queryParameters = queryParameters.set('statusEnvio', <any>statusEnvio);
        }
        if (tipoMensagem !== undefined && tipoMensagem !== null) {
            queryParameters = queryParameters.set('tipoMensagem', <any>tipoMensagem);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MensagemEmail>>('get',`${this.basePath}/v1/mensagens`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Anexos da Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdAnexosGet(mensagemId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Anexo>>;
    public v1MensagensMensagemIdAnexosGet(mensagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Anexo>>>;
    public v1MensagensMensagemIdAnexosGet(mensagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Anexo>>>;
    public v1MensagensMensagemIdAnexosGet(mensagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdAnexosGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Anexo>>('get',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}/anexos`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Anexo ao Rascunho de Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param upfile 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdAnexosPostForm(mensagemId: number, upfile?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Anexo>;
    public v1MensagensMensagemIdAnexosPostForm(mensagemId: number, upfile?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Anexo>>;
    public v1MensagensMensagemIdAnexosPostForm(mensagemId: number, upfile?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Anexo>>;
    public v1MensagensMensagemIdAnexosPostForm(mensagemId: number, upfile?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdAnexosPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (upfile !== undefined) {
            formParams = formParams.append('upfile', <any>upfile) as any || formParams;
        }

        return this.httpClient.request<Anexo>('post',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}/anexos`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Rascunho de Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdDelete(mensagemId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1MensagensMensagemIdDelete(mensagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1MensagensMensagemIdDelete(mensagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1MensagensMensagemIdDelete(mensagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Enviar Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param reenviarSeJaEnviada 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdEnviarPut(mensagemId: number, reenviarSeJaEnviada: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1MensagensMensagemIdEnviarPut(mensagemId: number, reenviarSeJaEnviada: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1MensagensMensagemIdEnviarPut(mensagemId: number, reenviarSeJaEnviada: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1MensagensMensagemIdEnviarPut(mensagemId: number, reenviarSeJaEnviada: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdEnviarPut.');
        }

        if (reenviarSeJaEnviada === null || reenviarSeJaEnviada === undefined) {
            throw new Error('Required parameter reenviarSeJaEnviada was null or undefined when calling v1MensagensMensagemIdEnviarPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reenviarSeJaEnviada !== undefined && reenviarSeJaEnviada !== null) {
            queryParameters = queryParameters.set('reenviarSeJaEnviada', <any>reenviarSeJaEnviada);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}/enviar`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consultar Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdGet(mensagemId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<MensagemEmail>>;
    public v1MensagensMensagemIdGet(mensagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MensagemEmail>>>;
    public v1MensagensMensagemIdGet(mensagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MensagemEmail>>>;
    public v1MensagensMensagemIdGet(mensagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MensagemEmail>>('get',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Rascunho de Mensagem de E-mail
     * 
     * @param mensagemId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensMensagemIdPut(mensagemId: number, body?: UpdMensagemEmail, observe?: 'body', reportProgress?: boolean): Observable<MensagemEmail>;
    public v1MensagensMensagemIdPut(mensagemId: number, body?: UpdMensagemEmail, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MensagemEmail>>;
    public v1MensagensMensagemIdPut(mensagemId: number, body?: UpdMensagemEmail, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MensagemEmail>>;
    public v1MensagensMensagemIdPut(mensagemId: number, body?: UpdMensagemEmail, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mensagemId === null || mensagemId === undefined) {
            throw new Error('Required parameter mensagemId was null or undefined when calling v1MensagensMensagemIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MensagemEmail>('put',`${this.basePath}/v1/mensagens/${encodeURIComponent(String(mensagemId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Rascunho de Mensagem de E-mail
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1MensagensPost(body?: NewMensagemEmail, observe?: 'body', reportProgress?: boolean): Observable<MensagemEmail>;
    public v1MensagensPost(body?: NewMensagemEmail, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MensagemEmail>>;
    public v1MensagensPost(body?: NewMensagemEmail, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MensagemEmail>>;
    public v1MensagensPost(body?: NewMensagemEmail, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MensagemEmail>('post',`${this.basePath}/v1/mensagens`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
